import {types} from '../../types';

const setGetUsersAction = (payload) => {
    return {
        type: types.users.SET_USERS_LIST_MOBILE,
        payload,
      }
}

const setGetUserAction = (payload) => {
  return {
      type: types.users.SET_USER_BY_ID_MOBILE,
      payload,
    }
}

const setGetRezymeAction = (payload) => {
  return {
    type: types.users.SET_REZYME_MOBILE,
    payload
  }
}

const setGetLastOperationAction = (payload) => {
  return {
    type: types.users.SET_LAST_OPERATION_MOBILE,
    payload
  }
}

const setGetReplenishmentUserAction = (payload) => {
  return {
    type: types.users.SET_REPLENISHMENT_USER_MOBILE,
    payload
  }
}

const setGetWithdrawalsUserAction = (payload) => {
  return {
    type: types.users.SET_WITHDRAWALS_USER_MOBILE,
    payload,
  }
}

const setGetHistoryBonusGetByIdAction = (payload) => {
  return {
    type: types.users.SET_BONUSES_HISTORY_MOBILE,
    payload
  }
}

const setGetJackpotHistoryListAction = (payload) => {
  return {
      type: types.users.SET_HISTORY_LIST_MOBILE,
      payload,
    }
}

const setGetJackpotListAction = (payload) => {
  return {
      type: types.users.SET_JACKPOT_MOBILE,
      payload,
    }
}


export {
  setGetUsersAction as SetGetUsersAction,
  setGetUserAction as SetGetUserAction,
  setGetRezymeAction as SetGetRezymeAction,
  setGetLastOperationAction as SetGetLastOperationAction,
  setGetReplenishmentUserAction as SetGetReplenishmentUserAction,
  setGetWithdrawalsUserAction as SetGetWithdrawalsUserAction,
  setGetHistoryBonusGetByIdAction as SetGetHistoryBonusGetByIdAction,
  setGetJackpotHistoryListAction as SetGetJackpotHistoryListAction,
  setGetJackpotListAction as SetGetJackpotListAction
}